import apiClient from '../apiClient';
import { GET_TEMPLATE_RESTAURANT_ITEM_DATA_URL } from '../apiUrl';

const getTemplateRestaurantItemApi = () => {
  return apiClient.get(GET_TEMPLATE_RESTAURANT_ITEM_DATA_URL);
};

export default getTemplateRestaurantItemApi;
